import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ArrowLeft } from "lucide-react";

interface DescriptionStepProps {
  description: string;
  onDescriptionChange: (description: string) => void;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export const DescriptionStep = ({
  description,
  onDescriptionChange,
  onBack,
  onSubmit,
  isSubmitting,
}: DescriptionStepProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-primary-dark mb-4">
        Describe what happened
      </h3>
      <Textarea
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        className="min-h-[150px]"
        placeholder="Please provide details about the incident..."
      />
      <div className="flex justify-between pt-4">
        <Button
          variant="outline"
          onClick={onBack}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Button>
        <Button
          onClick={onSubmit}
          disabled={!description || isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit Claim"}
        </Button>
      </div>
    </div>
  );
};